import React from "react";
import { Activity, Layers, Route, Sigma } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useGetReadCycleSummary } from "../../hooks";

export const Dashboard: React.FC = () => {
  const { data: summaryData = [] } = useGetReadCycleSummary();

  const kpiCards = [
    {
      title: "Total Read Cycles",
      count: summaryData?.totalReadCycles || 0,
      trendSummary: "All cycles created across the system",
      tooltip:
        "Total number of read cycles created in the system, regardless of status.",
      icon: <Layers className="h-8 w-8 text-blue-600" />,
    },
    {
      title: "Average Routes per Cycle",
      count: summaryData?.averageRoutesPerCycle || 0,
      trendSummary: "Balance route distribution across cycles",
      tooltip: "The average number of routes contained within each read cycle.",
      icon: <Sigma className="h-8 w-8 text-purple-600" />,
    },
    {
      title: "Cycle with Highest Routes",
      count: summaryData?.cycleWithHighestRoutesName || 0,
      trendSummary: `Routes: ${summaryData?.cycleWithHighestRoutesCount}`,
      tooltip:
        "The read cycle that contains the highest number of routes (with count).",
      icon: <Activity className="h-8 w-8 text-emerald-600" />,
    },
    {
      title: "Routes Covered (All Cycles)",
      count: summaryData?.routesCovered || 0,
      trendSummary: "Aggregate coverage across all cycles",
      tooltip:
        "Total number of routes included across all created read cycles.",
      icon: <Route className="h-8 w-8 text-green-600" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {kpiCards.map((card, index) => (
        <QuickStatsCard
          key={index}
          title={card.title}
          count={card.count}
          trendSummary={card.trendSummary}
          tooltip={card.tooltip}
          icon={card.icon}
          trendDirection={"up"}
        />
      ))}
    </div>
  );
};
